/**
 * @param {object} opts
 * @param {string} opts.regexType
 * @returns {RegExp|string}
 */

const getRegex = (opts = {}) => {
  const staticRegex = {
    lettersOnly: new RegExp('^[A-Za-z]+$'),
    lettersAndDashes: new RegExp('^[A-Za-z\\-]+$'),
    lettersDashesAndSpaces: new RegExp('^([a-zA-Z\\s\\-]+)$'),
    notLettersDashesPeriodsAndSpaces: new RegExp('[^a-zA-Z\\s\\-\\.]', 'g'),
    lettersDashesNumbersAndSpaces: new RegExp('^([a-zA-Z0-9\\s\\-]+)$'),
    notLettersDashesNumbersPoundsPeriodsAndSpaces: new RegExp(
      '[^a-zA-Z0-9#\\s\\-\\.]',
      'g'
    ),
    lettersDashesAndUnderscores: new RegExp('^[A-Za-z_\\-]+$'),
    emailRegex: /^\w+([+\.-]\w{1,64})*@\w+(\.\w{2,3})+$/,
    passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&(){}[\]|¬¦! "£$%^&*<>:;'#~_\-+=,@.`/\\])[A-Za-z\d@$!%*?&(){}[\]|¬¦! "£$%^&*<>:;'#~_\-+=,@.`/\\]{8,}$/,
    spaceRegEx: new RegExp(/ |\+/, 'g'),
    specialCharacters: new RegExp(/([.;,=!@#$%^&*()]+)/, 'g'),
    dashRegEx: new RegExp('-', 'g'),
    underscoreRegEx: new RegExp('_', 'g'),
    apostropheRegEx: new RegExp("'", 'g'),
    zipRegex: /^[0-9]{5}$/,
    peopleInvalidRegex: /[\[\]/!@#$%^&*(),^.\.{3,}\u2026\\.\\.\\.?~`À-ÿ‘’"“”:;{}|<>_\\=+\d]/g,
    // Name/city fields: ASCII letters plus spaces, hyphens, and apostrophes
    letterFieldValueRegex: /^[a-zA-Z\s'-]+$/,
    notLetterFieldAllowedChars: /[^a-zA-Z\s'-]/g,
    letterFieldCharRegex: /^[a-zA-Z\s'-]$/,
    letterFieldLetterOnlyCharRegex: /^[a-zA-Z]$/,
    // Strips non-Latin script chars; preserves spaces, periods, hyphens, and apostrophes
    latinUnicodeRegex: /[^\p{Script=Latin}\s.\-']/gu,
    // Strips chars not used in name, phone, email, or US address advanced search input
    advancedSearchInvalidRegex: /[^a-zA-Z\d\s,.\-#'@+_()/]/g,
    streetValidationRegex: /^\d+[a-zA-Z0-9\-]*\s+(?=(?:.*[a-zA-Z]){1,})[a-zA-Z0-9\-]+(?:\s+[a-zA-Z0-9\-]+)*(?:\s*#\s*\d+|(?:\s+[a-zA-Z]+\s*\d+)*)?$/i,
    poBoxRegex: /\b(?:Po|P\.O|P\/O|Post\sOffice)\sBox\b/i,
    phoneNumberRegex: /^(?:\(\d{3}\)|\d{3})[\s-]?\d{3}[\s-]?\d{4}$/,
    streetValidationRegex: /^\d+[a-zA-Z0-9\-]*\s+(?=(?:.*[a-zA-Z]){1,})[a-zA-Z0-9\-]+(?:\s+[a-zA-Z]+)*(?:\s*#\s*\d+|(?:\s+[a-zA-Z]+\s*\d+)*)?$/i,
    addressParamRegex: /^(.+)--([^-]+(?:_[^-]+)*)-([^-]+)-([^-]+)$/,
    poBoxRegex: /\b(?:Po|P\.O|P\/O|Post\sOffice)\sBox\b/i
  };

  if (!opts.regexType || !staticRegex.hasOwnProperty(opts.regexType)) {
    return '';
  }

  return staticRegex[opts.regexType];
};

export default getRegex;
